import {CurrentUser, currentUserClient} from 'common/report/queries/app-api/user-metadata-client';
import {ApiSingleValueResource} from 'common/util/model-resource/api-resource';

export {CurrentUser};

/** Note: this will not include workspace info (for efficiency) */
export class CurrentUserResource extends ApiSingleValueResource<CurrentUser> {
  apiClient = currentUserClient;
}
